function groupByCriteria(images) {
  const buckets = new Map();
  for (const img of images) {
    const key = `${img.genre}_${img.AspectRatio}_${img.Balance}`;
    if (!buckets.has(key)) {
      buckets.set(key, []);
    }
    buckets.get(key).push(img);
  }
  return buckets;
}

function shuffleBucket(bucket) {
  for (let i = bucket.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [bucket[i], bucket[j]] = [bucket[j], bucket[i]];
  }
  return bucket;
}

function extractAndRotate(buckets) {
  const output = [];
  const keys = [...buckets.keys()];
  let added = true;

  while (added) {
    added = false;
    for (const key of keys) {
      const bucket = buckets.get(key);
      if (bucket && bucket.length > 0) {
        output.push(bucket.shift());
        added = true;
      }
    }
  }
  return output;
}

function prioritizeVivid(images) {
  const vividIdx = images.findIndex(img => img.genre === 'VIVID');
  if (vividIdx > 0) {
    const [vivid] = images.splice(vividIdx, 1);
    images.unshift(vivid);
  }
  return images;
}

function interleaveColorAndBW(images) {
  const colorImages = images.filter(img => img.Balance !== 'B&W');
  const bwImages = images.filter(img => img.Balance === 'B&W');
  const shuffledImages = [];
  let lastAddedAspectRatio = null;

  while (colorImages.length || bwImages.length) {
    const canAddColor = colorImages.length && lastAddedAspectRatio !== "16:9";
    const canAddBW = bwImages.length && lastAddedAspectRatio !== "16:9";
    let selectedImage = null;

    if (canAddColor && canAddBW) {
      selectedImage = Math.random() < 0.5 ? colorImages.shift() : bwImages.shift();
    } else if (canAddColor) {
      selectedImage = colorImages.shift();
    } else if (canAddBW) {
      selectedImage = bwImages.shift();
    } else if (colorImages.length) {
      selectedImage = colorImages.shift();
    } else if (bwImages.length) {
      selectedImage = bwImages.shift();
    }

    if (selectedImage) {
      shuffledImages.push(selectedImage);
      lastAddedAspectRatio = selectedImage.AspectRatio;
    }
  }
  return shuffledImages;
}

function distributeAndShuffle(data) {
  const images = [...data.images];
  const buckets = groupByCriteria(images);

  // Shuffle within each bucket
  for (const key of buckets.keys()) {
    buckets.set(key, shuffleBucket(buckets.get(key)));
  }

  const extractedImages = extractAndRotate(buckets);
  const prioritizedImages = prioritizeVivid(extractedImages);
  const shuffledImages = interleaveColorAndBW(prioritizedImages);

  return {
    copyright: data.copyright,
    images: shuffledImages,
  };
}

export default distributeAndShuffle;